import {
  getSizedButtonStyles,
  getSizedFlyoutAnchorStyles,
  getSizedSplitButtonStyles,
  getSpinButtonSizedStyles,
} from "@1js/acui-button";
import {
  getCheckboxSizedStyles,
  getMergedCheckboxSizedStyles,
} from "@1js/acui-checkbox";
import { AppComboBoxProps, getComboBoxSizedStyles } from "@1js/acui-combobox";
import { ActionControlSize } from "@1js/acui-common";
import {
  getSizedFontPickerStyles,
  smallFontPickerItemHeight,
} from "@1js/acui-font-picker";
import { getInputSizedStyles } from "@1js/acui-input";
import { getLabelSizedStyles } from "@1js/acui-label";
import { getRibbonSliderSizedStyles } from "@1js/acui-slider";

import { RibbonControlProps } from "../../Controls/RibbonControlProps";
import { getChangeColorsGallerySizedStyles } from "../../Controls/RibbonGallery/Galleries/RibbonChangeColorsGallery.styles";
import { getRibbonSizedFontGalleryStyles } from "../../Controls/RibbonGallery/Galleries/RibbonFontStylesGallery.styles";
import { getIconGallerySizedStyles } from "../../Controls/RibbonGallery/Galleries/RibbonIconGallery.styles";
import {
  getSizedTableStylesPreviewGalleryButtonStylingCallback,
  getSizedTableStylesPreviewGalleryStyles,
} from "../../Controls/RibbonGallery/Galleries/RibbonTableStylesGallery.styles";

export function getRibbonControlGroupItemsStyleProps(
  props: RibbonControlProps,
  size: ActionControlSize
): Partial<RibbonControlProps> {
  switch (props.type) {
    case "AppButtonProps":
    case "AppToggleButtonProps":
      return { styles: getSizedButtonStyles(size, props.styles) };
    case "AppFlyoutAnchorProps":
      return { styles: getSizedFlyoutAnchorStyles(props, size, props.styles) };
    case "AppSplitButtonProps":
      return {
        styles: getSizedSplitButtonStyles(
          props.label,
          size,
          props.hideLabel,
          props.styles
        ),
      };
    case "AppSpinButtonProps":
      const fullSpinButtonStyles = getSpinButtonSizedStyles(size, props.styles);
      return {
        styles: fullSpinButtonStyles.spinButtonStyles,
        buttonStyles: fullSpinButtonStyles.buttonStyles,
      };
    case "AppComboBoxProps":
      const comboBoxStyles = getComboBoxSizedStyles(size, props);
      return {
        styles: comboBoxStyles.styles,
        optionStyles: comboBoxStyles.optionStyles,
        iconStyles: comboBoxStyles.iconStyles,
        caretDownButtonStyles: comboBoxStyles.caretDownButtonStyles,
      } as Partial<AppComboBoxProps>;
    case "AppFontPickerProps":
      return {
        itemHeight:
          size === ActionControlSize.Small
            ? smallFontPickerItemHeight
            : undefined,
        styles: getSizedFontPickerStyles(size, props),
      };
    case "AppFontStylesPreviewGalleryProps":
      return {
        styles: getRibbonSizedFontGalleryStyles(size, props.styles),
      };
    case "RibbonTableStylesPreviewGalleryProps":
      return {
        styles: getSizedTableStylesPreviewGalleryStyles(size, props.styles),
        getTableStyling:
          getSizedTableStylesPreviewGalleryButtonStylingCallback(size),
      };
    case "AppIconPreviewGalleryProps":
      return {
        styles: getIconGallerySizedStyles(size, props.styles),
      };
    case "RibbonChangeColorsPreviewGalleryProps":
      return { styles: getChangeColorsGallerySizedStyles(size, props.styles) };
    case "AppCheckboxProps":
      return {
        styles: props.styles
          ? getMergedCheckboxSizedStyles(props.styles, size)
          : getCheckboxSizedStyles(size),
      };
    case "AppLabelProps":
      return { styles: getLabelSizedStyles(size, props.styles).styles };
    case "AppSliderProps":
      return { styles: getRibbonSliderSizedStyles(size, props.styles).styles };
    case "AppInputProps":
      return { styles: getInputSizedStyles(size) };
    default:
      return {};
  }
}
